// Design System "Technical Precision"
// Primario = amarillo #FFB800 con texto pizarra. Radio 8px, borde 1px,
// micro-interaccion por brillo (nada de sombras pesadas).
const ButtonStyle = {
  base: "cursor-pointer font-sans",
  btn: "block text-center font-bold rounded-lg px-5 py-2 text-label-sm ease-in-out duration-200 border border-transparent shadow-sm text-white",
  big: "text-body-md px-6 py-2.5",
  small: "text-xs px-3 py-1.5",
  outline:
    "!bg-white !text-on-surface !border-outline hover:!bg-surface-container-high !shadow-none",
  brand: "bg-primary hover:brightness-105 !text-on-primary !border-primary",
  amber: "bg-primary hover:brightness-105 !text-on-primary !border-primary",
  green: "bg-emerald-500 hover:bg-emerald-600",
  red: "bg-red-500 hover:bg-red-600",
  blue: "bg-blue-500 hover:bg-blue-600",
  orange: "bg-orange-500 hover:bg-orange-600",
  textOnly: "!bg-transparent !border-transparent !shadow-none !text-on-surface-variant hover:!text-on-surface",
  iconButton: "inline-block p-0 w-4 h-4",
  iconText: "pl-11",
  iconTextOnly: "pl-6",
  fullWidth: "!w-full",
  rounded: "rounded-full",
  relative: "relative",
  absolute: "absolute",
  alignLeft: "pl-6 pr-0",
  alignRight: "pl-0 pr-6",
  loading: `relative after:absolute after:w-4 after:h-4 after:right-1 after:top-4 after:z-10
  after:bg-[url('components/button/icons/ico-loader.svg')] after:bg-contain after:right-3 after:origin-center after:animate-loading`,
  xsmall: "text-xs px-3 py-1 font-medium",
};

export default ButtonStyle;
